import { render, staticRenderFns } from "./CategoriesTabletUp.vue?vue&type=template&id=70c6f82b&scoped=true&"
import script from "./CategoriesTabletUp.vue?vue&type=script&lang=js&"
export * from "./CategoriesTabletUp.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesTabletUp.vue?vue&type=style&index=0&id=70c6f82b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c6f82b",
  null
  
)

export default component.exports